module.exports = __webpack_public_path__ + "img/lane-crash.71f53dec.svg";